/* 动画类 */
class Animation {
  constructor(arg) {
    this.timer = null;
    this.interval = 30;
    this.stopTime = 1; //分钟
    this.stepLength = 1; //步长
    this.element = 'div';
    this.outDivId = '#page-login';
    this.lineWidth = '1px'; //线的宽度
    this.position = 3; //位置
    this.direction = arg.direction||'bottom'; //方向
  }
  //过滤数据
  filter() {
    this.stopTime *= 1000 * 60;
  }
  //设置间隔
  setInterval(v) {
    this.interval = v;
  }
  //创建元素
  createElement(el, attr, wrap) {
    let div = document.createElement(el);
    let body = document.body;
    let wrapDiv = '';
    //设置id或class

    div = this.setIdOrCls(el, attr);
    //写入到指定的元素里
    if (wrap != undefined) {
      wrapDiv = this.getIdOrCls(wrap);
      if (wrapDiv && wrapDiv.length > 0) {
        wrapDiv.append(div);

      } else {
        let self = this;
        let t = setInterval(function() {
          wrapDiv = self.getIdOrCls(wrap);
          if (wrapDiv) {
            wrapDiv.append(div);
            clearInterval(t)
          }
        }, 1000);
      }
    } else {
      body.append(div);
    }
    return div;
  }
  //获取元素id
  getIdOrCls(el) {
    let name = el.substr(1);
    if (el.indexOf('#') != -1) {
      return document.getElementById(name);
    } else if (el.indexOf('.') != -1) {
      return document.getElementsByClassName(name);
    } else {
      return false;
    }
  }
  //设置元素id
  setIdOrCls(el, attr) {
    let div = document.createElement(el);
    if (attr.indexOf('#') != -1) {
      div.id = attr.substr(1);
    }
    if (attr.indexOf('.') != -1) {
      div.className = attr.substr(1);
    }
    div.style.width = this.lineWidth;
    div.style.height = this.lineWidth;
    div.style.position = 'absolute';
    div.style.left = 0;
    return div;
  }
  //设置元素属性
  setAttr(el, attr) {
    el.style = attr;
    return el;
  }
  //删除指定的id元素
  deleteElement(clsOrId) {
    let idOrClsName = clsOrId.substr(1);
    if (clsOrId.indexOf('#') != 1) {
      document.getElementById(idOrClsName).remove();
    }
    if (clsOrId.indexOf('.') != -1) {
      document.getElementsByClassName(idOrClsName);
    }
  }
  //创建定时器
  startTimer(div) {
    let self = this;
    this.timer = setInterval(function() {
      let clientWidth = document.body.clientWidth;
      let clientHeight = document.body.clientHeight;
      let left = div.style.left;
      let top = div.style.top;
      left = Math.ceil(left.replace('px', ''));
      left = Math.round(Math.random() * clientWidth);
      top = Math.ceil(top.replace('px', ''));
      top = Math.round(Math.random() * clientHeight);
      div.style.left = left + 'px';
      if (self.direction == 'bottom') {
        div.style.bottom = '0px';
      }
      if (self.direction == 'top') {
        div.style.top = top + 'px';

      }
      div.style.height = top / self.position + 'px';
      div.style.width = self.lineWidth;
      div.style.borderRadius = left + 'px';
      div.style.background =
        'linear-gradient(0deg,rgba(255, 255, 0,1), rgb(255, 255, 0),rgba(255,0,0,0.9), rgba(10, 231, 255,0.5))';
      self.clearTimer(true)
    }, this.interval)
  }
  //停止动画
  clearTimer(flag) {
    if (flag == true) {
      this.stopTime -= this.interval;
      if (Math.ceil(this.stopTime) <= 0) {
        clearInterval(this.timer);
      }
    } else {
      clearInterval(this.timer)
    }
  }
  //获取6位16进制数
  getHexColor(num) {
    let res = '';
    for (let i = 0; i < num; i++) {
      let random = Math.round(Math.random() * 15);
      let list = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F'];
      res += list[random];
    }
    return res;
  }
  //设置多个元素
  addMultipleElement(num) {
    for (let i = 0; i < num; i++) {
      let div = this.createElement(this.element, '#' + this.element + i, this.outDivId);
      this.startTimer(div)
    }
  }
  //销毁定时器
  destroy(){
    clearInterval(this.timer);
  }
  //运行
  run() {
    this.filter();
    this.addMultipleElement(100);
  }
}
export default {
  Animation: Animation
}



// WEBPACK FOOTER //
// ./src/utils/animation.js